import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBodyText, FDBox, FDHeadlineText, FDPaper, FDTitleText,
} from '@facet-wealth/design';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import HowToAchieveSection from './HowToAchieveSection';
import MathSection from './MathSection';
import ListSection from './ListSection';

const ROADMAP_GOALS_NEXT_12_MONTHS_LIST_SECTION = 'roadmap-goals-next-12-months-list-section';
const ROADMAP_GOALS_NEXT_12_MONTHS_HOW_TO_ACHIEVE_SECTION = 'roadmap-goals-next-12-months-how-to-achieve-section';
const ROADMAP_GOALS_NEXT_12_MONTHS_MATH_SECTION = 'roadmap-goals-next-12-months-math-section';

const listSectionMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['focusGoalsTitle', 'outOfFocusGoalsTitle'], {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('focusGoalsSubtitle', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .done();

const howToAchieveSectionMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .done();

const mathSectionMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .done();


export const Content = () => {
  const { resource } = useMetaLayoutContext();
  const [showMathSection, setShowMathSection] = React.useState(false);
  const theme = useTheme();

  const listSection = resource.attr('sections')?.resources().findItem((section) => section.id() === ROADMAP_GOALS_NEXT_12_MONTHS_LIST_SECTION);
  const howToAchieveSection = resource.attr('sections')?.resources().findItem((section) => section.id() === ROADMAP_GOALS_NEXT_12_MONTHS_HOW_TO_ACHIEVE_SECTION);
  const mathSection = resource.attr('sections')?.resources().findItem((section) => section.id() === ROADMAP_GOALS_NEXT_12_MONTHS_MATH_SECTION);

  return (
    <>
      {listSection ? (
        <FDPaper appearance={'flat'} width={'100%'} padding={3}>
          <FDBox paddingY={2}>
            <MetaResourceRenderer
              resource={listSection}
              layout={ListSection}
              metaOverrideSet={listSectionMetaOverrideSet}
            />
          </FDBox>
        </FDPaper>
      ) : null}
      {howToAchieveSection ? (
        <FDPaper appearance={'flat'} width={'100%'}>
          <MetaResourceRenderer
            resource={howToAchieveSection}
            layout={HowToAchieveSection}
            LayoutProps={{
              showMathSectionButton: mathSection && !showMathSection,
              onMathSectionButtonClick: () => setShowMathSection(true),
            }}
            metaOverrideSet={howToAchieveSectionMetaOverrideSet}
          />
          {showMathSection ? (
            <>
              <hr style={{
                border: 'none',
                backgroundColor: `${theme.palette.facet.colorSunset500}`,
                margin: '0px',
                height: '1px',
                width: '100%',
              }}
              />
              <MetaResourceRenderer
                resource={mathSection}
                layout={MathSection}
                LayoutProps={{
                  onHideButtonClick: () => setShowMathSection(false),
                }}
                metaOverrideSet={mathSectionMetaOverrideSet}
              />
            </>
          ) : null
              }
        </FDPaper>
      ) : null}
    </>
  );
};
